import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackQuoteMessageSentParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteMessageSent";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackQuoteMessageSent = (
    parameters: PartialSpecific<TrackQuoteMessageSentParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackQuoteMessageSentParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        quote: ga.use.quote(options),
        ...options,
    };

    return (parameters: Partial<TrackQuoteMessageSentParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.quoteMessageSent({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackQuoteMessageSent;
